import Rules from '@/services/validation/rules/rules'
export default {
  data() {
    return {
      tipRules: [v => Rules.isRequired(v)],
      spoilRules: [v => Rules.isRequired(v)],
      hoursRules: [v => Rules.isRequiredWithZero(v)],
      qtyRules: [v => Rules.isRequiredWithZero(v)],
      costPriceRules: [v => Rules.isRequiredWithZero(v)],
      sellPriceRules: [v => Rules.isRequiredWithZero(v)],
      scaleWeightRules: [v => Rules.isRequiredWithZero(v)],
      siteWeightRules: [v => Rules.isRequiredWithZero(v)],
      tipWeightRules: [v => Rules.isRequiredWithZero(v)],
      wbDocketNumberRules: [
        v => Rules.minLength(v, 1),
        v => Rules.maxLength(v, 50)
      ],
      noteRules: [v => Rules.minLength(v, 1), v => Rules.maxLength(v, 250)],
      waivedAmountRules: [v => Rules.isRequiredWithZero(v)]
    }
  }
}
